import { render, staticRenderFns } from "./generalsettings.vue?vue&type=template&id=f68d8ebc&scoped=true"
import script from "./generalsettings.vue?vue&type=script&lang=js"
export * from "./generalsettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68d8ebc",
  null
  
)

export default component.exports